(() => {
  const locale = (document.documentElement.lang || 'fr').slice(0, 2).toLowerCase();
  const labels = {
    fr: { addToCart: 'Ajouter au panier', soldOut: 'Épuisé', unavailable: 'Indisponible', unavailable_with_option: '[value] - Indisponible' },
    en: { addToCart: 'Add to cart', soldOut: 'Sold out', unavailable: 'Unavailable', unavailable_with_option: '[value] - Unavailable' },
    de: { addToCart: 'In den Warenkorb', soldOut: 'Ausverkauft', unavailable: 'Nicht verfügbar', unavailable_with_option: '[value] - Nicht verfügbar' },
    es: { addToCart: 'Añadir al carrito', soldOut: 'Agotado', unavailable: 'No disponible', unavailable_with_option: '[value] - No disponible' },
    it: { addToCart: 'Aggiungi al carrello', soldOut: 'Esaurito', unavailable: 'Non disponibile', unavailable_with_option: '[value] - Non disponibile' },
    nl: { addToCart: 'Toevoegen aan winkelwagen', soldOut: 'Uitverkocht', unavailable: 'Niet beschikbaar', unavailable_with_option: '[value] - Niet beschikbaar' },
    pl: { addToCart: 'Dodaj do koszyka', soldOut: 'Wyprzedane', unavailable: 'Niedostępne', unavailable_with_option: '[value] - Niedostępne' }
  };
  window.variantStrings = Object.assign({}, window.variantStrings || {}, labels[locale] || labels.fr);
  if (!window.__maedenVariantFocusPatched) {
    const nativeFocus = HTMLElement.prototype.focus;
    HTMLElement.prototype.focus = function(options) {
      if (this.closest && this.closest('variant-selects')) {
        const safe = (options && typeof options === 'object') ? Object.assign({}, options, { preventScroll: true }) : { preventScroll: true };
        return nativeFocus.call(this, safe);
      }
      return nativeFocus.call(this, options);
    };
    window.__maedenVariantFocusPatched = true;
  }
})();